module.exports = __webpack_public_path__ + "img/back.4b3d8b1f.svg";